import CaptionOverlay from '@/components/captions/CaptionOverlay';

/**
 * Read-only subtitle overlay inside the export crop preview frame.
 * Uses the shared CaptionOverlay renderer (same engine as editor + Chromium export).
 */
export function ExportFramingSubtitleOverlay({
  frameW,
  frameH,
  aspectRatio,
  subtitleStyle,
  subtitleLayer,
  text = '',
  tokens = null,
  highlightColor = '#fde047',
  viewportMin = 900,
  layoutFrameW = null,
  layoutFrameH = null,
  showClipGuide = false,
}) {
  const trimmed = String(text || '').trim();
  if (!trimmed && !showClipGuide) return null;

  return (
    <CaptionOverlay
      text={trimmed}
      tokens={tokens}
      highlightColor={highlightColor}
      style={subtitleStyle}
      layer={subtitleLayer}
      frameW={frameW}
      frameH={frameH}
      aspectRatio={aspectRatio}
      viewportMin={viewportMin}
      layoutFrameW={layoutFrameW}
      layoutFrameH={layoutFrameH}
      placeholder={showClipGuide ? 'Subtitle' : ''}
      opacity={trimmed ? 1 : 0.65}
      showGuide={showClipGuide}
      guideClassName="rounded-sm border border-dashed border-violet-400/70"
      className="z-20"
      testId="export-framing-subtitle-overlay"
    />
  );
}
